import { createGlobalStyle } from "styled-components";

/* eslint-disable-next-line @typescript-eslint/naming-convention */
export const GlobalStyle = createGlobalStyle`
html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, main, menu, nav, output, ruby, section, summary, time, mark, audio, video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure, footer, header, hgroup, main, menu, nav, section {
  display: block;
}

/* HTML5 hidden-attribute fix for newer browsers */
*[hidden] {
  display: none;
}

body {
  line-height: 1;
}

ol, ul {
  list-style: none;
}

blockquote, q {
  quotes: none;
}

blockquote:before, blockquote:after, q:before, q:after {
  content: '';
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

button {
  appearance: none; 
  padding: 0; 
  border: none; 
  outline: none; 
  background-color: 
  transparent; 
  cursor: pointer; 
}

html { 
  color: #333333; 
  font-size: 14px; 
  line-height: 1.7; 
  letter-spacing: 0; 
  font-weight: normal; 
}

body { 
  font-family: '源ノ角ゴシック Regular', '源ノ角ゴシック', 'Noto Sans JP', 'Roboto', Helvetica, 'ヒラギノ角ゴ Pro W3', 'Hiragino Kaku Gothic Pro', 'メイリオ', 'Meiryo', 'Meiryo UI', sans-serif; 
  position: relative; 
}

body.en {
  font-family: 'Roboto', Helvetica, 'メイリオ', 'Meiryo', sans-serif;
}

h1 { 
  font-size: 2.86rem; 
  line-height: 3.14rem; 
  letter-spacing: 0.07rem; 
  font-weight: normal; 
}
h2 { 
  font-size: 2.29rem; 
  line-height: 2.57rem; 
  letter-spacing: 0.07rem; 
  font-weight: normal; 
}
h3 { 
  font-size: 1.71rem; 
  line-height: 2rem; 
  letter-spacing: 0.07rem; 
  font-weight: normal; 
}
h4 { 
  font-size: 1.29rem; 
  line-height: 1.57rem; 
  letter-spacing: 0.07rem; 
  font-weight: normal; 
}
h5 { 
  font-size: 1.14rem; 
  line-height: 1.57rem; 
  letter-spacing: 0.06rem; 
  font-weight: normal; 
}

@keyframes spin {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(359deg);
  }
}

input {
  padding: .5rem .8rem;
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: 0;
  font-weight: normal;
}
`;
